import { render, staticRenderFns } from "./ValidateRegistration.vue?vue&type=template&id=5e7d5404&scoped=true"
import script from "./ValidateRegistration.vue?vue&type=script&lang=js"
export * from "./ValidateRegistration.vue?vue&type=script&lang=js"
import style0 from "./ValidateRegistration.vue?vue&type=style&index=0&id=5e7d5404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d5404",
  null
  
)

export default component.exports